import React from 'react';

const StatusBadge = ({ status, size = 'default' }) => {
  const getStatusConfig = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return {
          color: 'bg-success text-success-foreground',
          label: 'Active'
        };
      case 'spare':
        return {
          color: 'bg-warning text-warning-foreground',
          label: 'Spare'
        };
      case 'repair':
        return {
          color: 'bg-error text-error-foreground',
          label: 'Repair'
        };
      case 'retired':
        return {
          color: 'bg-secondary text-secondary-foreground',
          label: 'Retired'
        };
      default:
        return {
          color: 'bg-muted text-muted-foreground',
          label: 'Unknown'
        };
    }
  };

  const config = getStatusConfig(status);
  const sizeClasses = size === 'sm' ? 'px-2 py-1 text-xs' : 'px-3 py-1 text-sm';

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${config?.color} ${sizeClasses}`}>
      {config?.label}
    </span>
  );
};

export default StatusBadge;